export default __webpack_public_path__ + "static/media/info-yellow.32627b7a.svg";